import React from 'react'

import { Button, Grid, Header, Image, Modal } from 'semantic-ui-react'

import { ITeam, IBrand } from '../../api/Data'

import ColorPicker from '../../components/common/ColorPicker'
import FontPickerComponent from '../../components/common/FontPickerComponent'

import imageOnboardingBranding from '../../_images/onboarding-branding.png'

const StyleModal = (props: IStyleModalProps) => {
  // Props
  const {
    loading,
    team,
    brand,
    setShowIconUploadModal,
    setShowFullLogoUploadModal,
    setShowWatermarkUploadModal,
    handleChangeFont,
    handleChangePrimaryColor,
    handleChangeSecondaryColor,
    stepBack,
    handleSaveStyle,
    handleEndOnboarding,
  } = props

  const {
    teamName,
    organisationDescription,
    organisationWebsite,
    logoAvatarUrl,
    logoUrl,
    logoWatermarkUrl,
    primaryFont,
    primaryColor,
    secondaryColor,
  } = team
  const brandFont = brand?.primaryFont?.trim()
  const brandFontNeedsSubstitution = !!brand && brandFont !== primaryFont

  return (
    <Modal open style={{ width: '100%', height: '100%', marginTop: '-14px' }}>
      <Modal.Content style={{ padding: 0 }}>
        <Grid style={{ height: '100vh', minHeight: '700px', margin: 0 }}>
          <Grid.Column
            only="computer"
            width={7}
            style={{ backgroundImage: 'linear-gradient(to bottom, #3121a0, #1f248e)' }}
          >
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Header inverted as="h1">
                Almost done - let's tailor Vloggi to your needs
              </Header>
              <Image src={imageOnboardingBranding} width={350} alt="vloggi" />
            </div>
          </Grid.Column>
          <Grid.Column mobile={16} computer={9}>
            <div style={{ display: 'flex', flexDirection: 'column', height: '100%', justifyContent: 'space-between' }}>
              <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Button disabled={loading} onClick={handleEndOnboarding}>
                  Skip
                </Button>
              </div>
              <div style={{ padding: '0 100px' }}>
                <Header as="h2">Customize your branding</Header>
                <div>
                  <p style={{ fontSize: '20px', fontWeight: 'bold' }}>{brand?.organisationName || teamName}</p>
                  {!!organisationDescription && <p>{organisationDescription}</p>}
                  {!!organisationWebsite && (
                    <p>
                      <a href={'http://' + organisationWebsite} target="_blank" rel="noopener noreferrer">
                        {organisationWebsite}
                      </a>
                    </p>
                  )}
                </div>
                <div style={{ display: 'flex', flexDirection: 'row', gap: '20px', flexWrap: 'wrap' }}>
                  <div>
                    <p style={{ margin: '20px 0 5px 0', fontSize: '13px' }}>Upload icon</p>
                    <Image
                      size="small"
                      src={`${logoAvatarUrl}?${Date.now()}`}
                      style={{
                        width: '120px',
                        height: '80px',
                        border: '1px solid #6c58fb',
                        borderRadius: '5px',
                        objectFit: 'contain',
                        cursor: 'pointer',
                      }}
                      onClick={() => setShowIconUploadModal(true)}
                    />
                  </div>
                  <div>
                    <p style={{ margin: '20px 0 5px 0', fontSize: '13px' }}>Full logo</p>
                    <Image
                      src={logoUrl ? `${logoUrl}&${Date.now()}` : undefined}
                      style={{
                        width: '120px',
                        height: '80px',
                        border: '1px solid #6c58fb',
                        borderRadius: '5px',
                        objectFit: 'contain',
                        cursor: 'pointer',
                      }}
                      onClick={() => setShowFullLogoUploadModal(true)}
                    />
                  </div>
                  <div>
                    <p style={{ margin: '20px 0 5px 0', fontSize: '13px' }}>Video watermark</p>
                    <Image
                      src={`${logoWatermarkUrl}?${Date.now()}`}
                      style={{
                        width: '120px',
                        height: '80px',
                        padding: '8px',
                        background: '#343434',
                        border: '1px solid #6c58fb',
                        borderRadius: '5px',
                        objectFit: 'contain',
                        cursor: 'pointer',
                      }}
                      onClick={() => setShowWatermarkUploadModal(true)}
                    />
                  </div>
                </div>
                <p style={{ margin: '20px 0 5px 0', fontSize: '13px' }}>Brand colors</p>
                <div style={{ display: 'flex', flexDirection: 'row', gap: '20px' }}>
                  <div style={{ width: '50px', position: 'relative' }}>
                    <small>Primary</small>
                    <ColorPicker colorHex={primaryColor} onChange={handleChangePrimaryColor} />
                  </div>
                  <div style={{ width: '50px', position: 'relative' }}>
                    <small>Secondary</small>
                    <ColorPicker colorHex={secondaryColor} onChange={handleChangeSecondaryColor} />
                  </div>
                </div>
                <p style={{ margin: '20px 0 5px 0', fontSize: '13px' }}>Font</p>
                <div style={{ width: '300px', margin: '0 0 10px 0' }}>
                  <FontPickerComponent activeFontFamily={primaryFont} onChange={handleChangeFont} />
                  {brandFontNeedsSubstitution && (
                    <p style={{ color: '#5f6472', lineHeight: 1.45, margin: '10px 0 0' }}>
                      {brandFont ? (
                        <>
                          Your brand uses <strong>{brandFont}</strong>. The closest available match is{' '}
                          <strong>{primaryFont}</strong>.
                        </>
                      ) : (
                        <>
                          Your exact brand font isn’t available, so we’ve selected <strong>{primaryFont}</strong> as the
                          closest available match.
                        </>
                      )}
                    </p>
                  )}
                </div>
                <Button
                  primary
                  disabled={loading}
                  loading={loading}
                  style={{ marginTop: '20px' }}
                  onClick={handleSaveStyle}
                >
                  Next
                </Button>
              </div>
              <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <div style={{ margin: '12px 20px 0 0' }}>3 / 6</div>
                <Button disabled={loading} onClick={stepBack}>
                  Back
                </Button>
              </div>
            </div>
          </Grid.Column>
        </Grid>
      </Modal.Content>
    </Modal>
  )
}

interface IStyleModalProps {
  loading: boolean
  team: ITeam
  brand: IBrand | null
  setShowIconUploadModal: (arg: boolean) => void
  setShowFullLogoUploadModal: (arg: boolean) => void
  setShowWatermarkUploadModal: (arg: boolean) => void
  handleChangeFont: (arg: { family: string }) => void
  handleChangePrimaryColor: (arg: { hex: string }) => void
  handleChangeSecondaryColor: (arg: { hex: string }) => void
  stepBack: () => void
  handleSaveStyle: () => void
  handleEndOnboarding: () => void
}

export default StyleModal
